import { Component, Inject, OnInit, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { DateTime } from "luxon";
import { TicketService } from "../../../services/ticket.service";
import {
  MateraStatementResponse,
  EntryType,
  Entry,
  Period,
} from "../../../model/domain/Matera";

@Component({
  selector: "app-eletronic-transfer-statement-dialog",
  templateUrl: "./eletronic-transfer-statement-dialog.component.html",
  styleUrls: ["./eletronic-transfer-statement-dialog.component.css"],
})
export class EletronicTransferStatementDialogComponent {
  form: FormGroup;

  bankAccount: string;
  operationDate: DateTime;

  materaStatement: MateraStatementResponse = new MateraStatementResponse();
  entries: Entry[];
  period: Period = new Period();
  entryTypesDescription: { [x: number]: string } = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private service: TicketService
  ) {
    this.bankAccount = data.bankAccount;
    this.operationDate = data.operationDate;

    this.entryTypesDescription = EntryType;

    this.getStatement();
  }

  getStatement() {
    this.service
      .getEletronicTransferStatement(this.bankAccount, this.operationDate)
      .subscribe((q) => {
        this.materaStatement = q;
        this.entries = this.materaStatement.statement.entries;
        this.period = this.materaStatement.statement.period;
      });
  }
}
